import i18n from 'i18next';
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next';
var currentLang: any = localStorage.getItem("language");

var MULTILANG_ENDPOINT = process.env.REACT_APP_ENVIRONMENT == 'prod' ? process.env.REACT_APP_CLIENT_PROD_ENDPOINT : process.env.REACT_APP_CLIENT_DEV_ENDPOINT
i18n
    .use(i18nBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: currentLang,
        lng: currentLang ? currentLang : "en",
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: `${MULTILANG_ENDPOINT}/i18n/{{lng}}.json`,
        }
    });

export default i18n;